<template>
    <div class="login-content-wrapper">
        <div class="img-desktop d-none d-lg-inline-block img-desktop-login"></div>
        <section class="content">
            <div class="container-fluid">
<!--                <div class="login-logo-container">-->
<!--                    <img src="@/assets/img/logoAfflexBaseline.png" alt="Afflex logo">-->
<!--                </div>-->
                <div class="row mt-4">
                    <div class="col-md-6 form-request-content">
                        <div class="request-title request-title--login">
                            <h1>Je me connecte au service de gestion de DUE et de dispenses d'affiliation</h1>
                        </div>
                        <!-- Warning alert -->
                        <div v-show="isAlertVisible"
                             class="alert alert-warning alert-dismissible"
                        >
                            <button type="button"
                                    class="close"
                                    @click="isAlertVisible = !isAlertVisible"
                            >×</button>
                            <h5>
                                <i class="icon fas fa-exclamation-triangle"></i>
                                <span>E-mail ou mot de passe incorrect. Réessayez ou cliquez sur
                                  "Mot de passe oublié" pour le reinitialiser</span>
                            </h5>
                        </div>
                        <!-- Warning alert -->

                        <form novalidate="novalidate"
                              class="needs-validation"
                        >
                            <!-- Email -->
                            <label class="required-field-asterisks required"
                                   for="email"
                            >Email</label>
                            <input type="text"
                                   id="email"
                                   class="form-control form-control-lg"
                                   placeholder="Email"
                                   :class="{ 'is-invalid': $v.formData.email.$error }"
                                   @input="delayTouch($v.formData.email)"
                                   v-model="formData.email"
                            >
                            <FormError error="Format de l'email incorrect"
                                       v-if="!$v.formData.email.email && $v.formData.email.$dirty"
                            ></FormError>
                            <FormError error="Veuillez renseigner l’email"
                                       v-if="!$v.formData.email.required && $v.formData.email.$dirty"
                            ></FormError>
                            <!-- Email -->

                            <!-- Password -->
                            <label class="required-field-asterisks required"
                                   for="password"
                            >Mot de passe</label>
                            <input type="password"
                                   id="password"
                                   class="form-control form-control-lg"
                                   placeholder="Mot de passe"
                                   :class="{ 'is-invalid': $v.formData.password.$error }"
                                   @input="delayTouch($v.formData.password)"
                                   v-model="formData.password"
                            >
                            <!-- Password -->
                        </form>

                        <div class="login-links col-md-12">
                            <router-link :to="{ name: 'reset-password' }">Mot de passe oublié?</router-link>
                        </div>
                    </div>

                    <div class="input-group col-md-10 mx-sm-auto my-md-4 login-btn__wrapper">
                        <div class="mx-sm-auto">
                            <button class="btn btn-success btn-lg ml-4 btn-link btn__save"
                                    :disabled="isLoading || $v.$invalid"
                                    @click.prevent="submit"
                            >
                                <span>Se connecter</span>
                                <ButtonSpinner :isLoading="isLoading"></ButtonSpinner>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import ButtonSpinner from '../../components/ButtonSpinner';
    import FormError from '../../components/FormError';
    import ValidationDelayTouch from '../../mixins/validationDelayTouch';
    import { login, fetchUserPermissions, firstLoginFrontPasswordReset, fetchUser } from '@/service/api/user.api';
    import { email, required } from 'vuelidate/lib/validators';
    import { mapActions } from 'vuex';
    import ROLES from '../../utils/constants'
    import { fetchEnterprises } from "@/service/api/enterprise.api";

    export default {
        mixins: [ValidationDelayTouch],
        data() {
            return {
                formData: {
                    email: '',
                    password: ''
                },
                isLoading: false,
                isAlertVisible: false
            }
        },
        methods: {
            ...mapActions({
                setAccessToken: 'setAccessToken',
                setCompany: 'setCompany',
                setUserPermissions: 'setUserPermissions',
                deleteUserPermissions: 'deleteUserPermissions',
                setRole: 'setRole',
                deleteRole: 'deleteRole',
                setEnterpriseData: 'setEnterpriseData',
                deleteAccessToken: 'deleteAccessToken',
                loadScopeSettings: 'loadScopeSettings',
            }),
            async submit() {
                try {
                    this.isLoading = true;
                    this.isAlertVisible = false;
                    const { data } = await login({
                        login: this.formData.email,
                        password: this.formData.password
                    });

                    this.setAccessToken(data.accessToken);

                    const response = await fetchUser(data.user.id);

                    if (!this.hasUserAlreadyLoggedIn(response)) {
                        this.setRole(data.user.roles[0]);
                        await this.redirectToFirstUserLogin(response);
                        return;
                    }

                    this.deleteUserPermissions();
                    this.deleteRole();

                    this.setCompany(data.user.tdc1Company);
                    this.setRole(data.user.roles[0]);

                    const responseData = await fetchUserPermissions();

                    this.setUserPermissions(responseData.data);
                    await this.redirectByRole(data.user.roles[0]);
                } catch (error) {
                    console.error(error);
                    this.isLoading = false;
                    this.isAlertVisible = true;
                }
            },
            async redirectByRole(role) {
                if (role === ROLES.ROLE_ENTERPRISE_USER) {
                    const { data } = await fetchEnterprises(this.pagination);
                    const { items, totalItems } = data;

                    if (totalItems !== 1) {
                        await this.loadScopeSettings();
                        this.isLoading = false;
                        return;
                    }

                    await this.setEnterpriseData(items[0]);

                    this.isLoading = false;
                    await this.$router.push({ name: 'exemption-list'}).catch(() => {});
                }

                if (role === ROLES.ROLE_TDC1_MANAGER || role === ROLES.ROLE_TDC2_MANAGER) {
                    await this.loadScopeSettings();
                    this.isLoading = false;
                    await this.$router.push({ name: 'enterprise-list'}).catch(() => {});
                    return;
                }

                this.isLoading = false;
            },
            hasUserAlreadyLoggedIn(response) {
                const { data } = response;

                return Object.prototype.hasOwnProperty.call(data, "lastLoginAt") && data.lastLoginAt;
            },
            async redirectToFirstUserLogin(response) {
                const resetPasswordToken = await this.getResetPasswordToken(response);

                this.deleteAccessToken();

                await this.$router.push({
                  name: 'first-user-login',
                  params: { resetPasswordToken }
                }).catch(() => {});
            },
            async getResetPasswordToken(response) {
                const { data }= await firstLoginFrontPasswordReset({
                    id: response.data.id
                });

                return data.accessToken;
            }
        },
        validations: {
           formData: {
               email: {
                   email,
                   required
               },
               password: {
                   required
               }
           }
        },
        components: {
            ButtonSpinner,
            FormError
        }
    }
</script>
